import React, { useCallback } from 'react';
import { webConfig } from '../../utils/webConfig';

type DonorAvatarProps = {
    id?: string;
    src?: string | null;
    title?: string;
    className?: string;
};

export const DonorAvatar: React.FC<DonorAvatarProps> = ({
    id,
    src,
    title,
    className,
}) => {
    const imageRef = React.useRef<HTMLImageElement>(null);

    const handleError = useCallback(() => {
        if (!imageRef.current) {
            return;
        }
        imageRef.current.src = webConfig.doneeAvatarDefault;
    }, []);

    return (
        <img
            id={id}
            ref={imageRef}
            src={src || webConfig.doneeAvatarDefault}
            title={title}
            alt={title}
            className={className}
            onError={handleError}
        />
    );
};
